import { render, staticRenderFns } from "./EmrColumnManageCreate.vue?vue&type=template&id=5fb70fb2&scoped=true&"
import script from "./EmrColumnManageCreate.vue?vue&type=script&lang=js&"
export * from "./EmrColumnManageCreate.vue?vue&type=script&lang=js&"
import style0 from "./EmrColumnManageCreate.vue?vue&type=style&index=0&id=5fb70fb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb70fb2",
  null
  
)

export default component.exports